import React from 'react'
import './index.css'

/**
 * @param count
 * @param isFullSize
 * @returns {JSX.Element|null}
 * @constructor
 */
const ProductOrderedRecently = ({
  count,
  isFullSize
}) => {
  if (!count) {
    return <></>
  }

  if (!isFullSize) {
    return <></>
  }

  const countStr = count.toLocaleString()

  return (
    <span className='product-ordered-count'>
      {`${countStr} ordered recently`}
    </span>
  )
}

export default ProductOrderedRecently
